module.exports = __webpack_public_path__ + "img/crock-pot-mexican-chicken-soup.47f3fc5e.jpg";